import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class AddButton extends ThemeComponent {
    @Ref() button!: HTMLButtonElement;

    constructor() {
        super();
    }

    init() {
        this.$listen(this.button, 'click', () => {
            const productFormSubmit =
            document.querySelector('.product-form__submit') as HTMLButtonElement;
            if (productFormSubmit) {
                productFormSubmit.click();
            }
        });
    }

}
